var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "custom_header"
  }, [(_vm.impersonating) ? _c('div', {
    staticClass: "impersonation-banner",
    attrs: {
      "data-testid": "impersonation-banner"
    }
  }, [_c('strong', [_vm._v("Impersonace:")]), _vm._v("\n        " + _vm._s(_vm.originalFullname) + " pracuje jako " + _vm._s(_vm.userFullname) + ".\n        "), _c('button', {
    staticClass: "btn btn-sm btn-light ml-2",
    attrs: {
      "type": "button",
      "data-testid": "stop-impersonation",
      "disabled": _vm.stoppingImpersonation
    },
    on: {
      "click": _vm.stopImpersonation
    }
  }, [_vm._v("Vrátit se k původnímu uživateli")]), _vm._v(" "), (_vm.impersonationError) ? _c('span', {
    staticClass: "ml-2"
  }, [_vm._v(_vm._s(_vm.impersonationError))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.userFullname) ? _c('div', {
    staticClass: "app-header navbar justify-content-between"
  }, [_c('b-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "#"
    }
  }, [_vm._v("clinico")]), _vm._v(" "), _c('ul', {
    staticClass: "navbar-nav"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [(_vm.$route.name !== 'Home') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'Home'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('i', {
    staticClass: "fa fa-home fa-2x text-secondary",
    attrs: {
      "aria-hidden": "true"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [(_vm.$route.name !== 'Result') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'Result'
      },
      "data-testid": "nav-lab-results"
    }
  }, [_c('i', {
    staticClass: "fa fa-flask fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('i', {
    staticClass: "fa fa-flask fa-2x text-secondary",
    attrs: {
      "aria-hidden": "true"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [(_vm.$route.name !== 'Calendar') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'Calendar'
      },
      "data-testid": "nav-calendar"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('i', {
    staticClass: "fa fa-calendar fa-2x text-secondary",
    attrs: {
      "aria-hidden": "true"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [(_vm.$route.name !== 'ClientRegistration') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'ClientRegistration'
      },
      "data-testid": "nav-register-client"
    }
  }, [_c('i', {
    staticClass: "fa fa-user-plus fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('i', {
    staticClass: "fa fa-user-plus fa-2x text-secondary",
    attrs: {
      "aria-hidden": "true"
    }
  })], 1), _vm._v(" "), (_vm.hasRole('manager')) ? _c('li', {
    staticClass: "nav-item"
  }, [(_vm.$route.name !== 'ContractualReporting') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'ContractualReporting'
      },
      "data-testid": "nav-contractual-reporting"
    }
  }, [_c('i', {
    staticClass: "fa fa-coins fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('i', {
    staticClass: "fa fa-coins fa-2x text-secondary",
    attrs: {
      "aria-hidden": "true"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hasRole('analyst')) ? _c('li', {
    staticClass: "nav-item"
  }, [(_vm.$route.name !== 'Statistic') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'Statistic'
      },
      "data-testid": "nav-statistics"
    }
  }, [_c('i', {
    staticClass: "fa fa-chart-line fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('i', {
    staticClass: "fa fa-chart-line fa-2x text-secondary",
    attrs: {
      "aria-hidden": "true"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('multiselect', {
    attrs: {
      "reset-after": true,
      "id": "search",
      "data-testid": "client-search",
      "label": "label",
      "track-by": "code",
      "placeholder": "vyhledat klienta",
      "open-direction": "bottom",
      "options": _vm.clients,
      "multiple": false,
      "searchable": true,
      "internal-search": false,
      "close-on-select": true,
      "options-limit": 300,
      "limit": 3,
      "max-height": 600,
      "show-no-results": false,
      "clear-on-select": true,
      "selectLabel": ""
    },
    on: {
      "search-change": _vm.getResult,
      "select": _vm.openClient
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc",
          attrs: {
            "data-testid": "client-search-option"
          }
        }, [_c('span', {
          staticClass: "option__title",
          class: props.option.available === true ? 'available' : 'unavailable'
        }, [_c('div', {
          staticClass: "row m-0 pb-1"
        }, [_c('div', {
          staticClass: "col-sm-6",
          attrs: {
            "data-testid": "client-search-option-name"
          }
        }, [_vm._v(_vm._s(props.option.full_name_reversed))]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-6 text-right",
          attrs: {
            "data-testid": "client-search-option-pin"
          }
        }, [_vm._v(_vm._s(props.option.pin_in_bd))])]), _vm._v(" "), _c('div', {
          staticClass: "row m-0 font-sm"
        }, [_c('div', {
          staticClass: "col-sm-12"
        }, [_c('span', [_vm._v(_vm._s(props.option.default_email_address))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(props.option.default_phone_number))])])])])])]
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('span', {}, [_c('span', {
    attrs: {
      "data-testid": "medic-name"
    }
  }, [_vm._v(_vm._s(_vm.userFullname))]), _c('i', {
    staticClass: "navbar-toggler fa fa-lock",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.authLock
    }
  }), _c('i', {
    staticClass: "navbar-toggler fa fa-sign-out",
    attrs: {
      "data-testid": "logout",
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.authLogout
    }
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.isAuthenticated && _vm.client) ? _c('div', {
    staticClass: "app-header navbar second_row",
    attrs: {
      "data-testid": "client-banner"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-between w-100 align-items-center"
  }, [_c('div', {}, [_c('client-detail', {
    attrs: {
      "client": _vm.client
    },
    on: {
      "reload-client": _vm.reloadClient
    }
  }), _vm._v(" "), _c('client-insurance', {
    attrs: {
      "client": _vm.client
    },
    on: {
      "reload-client": _vm.reloadClient
    }
  }), _vm._v(" "), _c('client-membership', {
    attrs: {
      "client": _vm.client
    },
    on: {
      "reload-client": _vm.reloadClient
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }, [_vm._v("|")]), _vm._v(" "), _c('client-address', {
    attrs: {
      "client": _vm.client
    },
    on: {
      "reload-client": _vm.reloadClient
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }, [_vm._v("|")]), _vm._v(" "), _c('client-email-address', {
    attrs: {
      "client": _vm.client
    },
    on: {
      "reload-client": _vm.reloadClient
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }, [_vm._v("|")]), _vm._v(" "), _c('client-phone-number', {
    attrs: {
      "client": _vm.client
    },
    on: {
      "reload-client": _vm.reloadClient
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }, [_vm._v("|")]), _vm._v(" "), _c('client-gdpr-consent', {
    attrs: {
      "client": _vm.client
    },
    on: {
      "reload-client": _vm.reloadClient
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }, [_vm._v("|")]), _vm._v(" "), _c('router-link', {
    staticClass: "text-secondary",
    attrs: {
      "to": {
        name: 'ShowClient',
        params: {
          clientid: _vm.client.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-address-card-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "text-secondary",
    attrs: {
      "data-testid": "client-banner-log"
    },
    on: {
      "click": _vm.showModalClientLog
    }
  }, [_c('i', {
    staticClass: "fa fa-history",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "text-secondary",
    attrs: {
      "target": "_blank",
      "href": _vm.setting.hostname + 'client/' + _vm.client.id + '/label/pdf'
    }
  }, [_c('i', {
    staticClass: "fa fa-tag",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('client-p-s-a', {
    attrs: {
      "client": _vm.client
    },
    on: {
      "reload-client": _vm.reloadClient
    }
  }), _vm._v(" "), (_vm.editingClientNote === true) ? [_c('form', {
    staticClass: "form-inline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.saveClient()
      }
    }
  }, [_c('label', {
    attrs: {
      "for": "note"
    }
  }, [_vm._v("poznámka: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.note),
      expression: "client.note"
    }],
    staticClass: "form-control ml-sm-1 mr-sm-2 col-sm-4",
    attrs: {
      "type": "text",
      "aria-describedby": "noteHelp",
      "id": "note",
      "data-testid": "client-banner-note-input"
    },
    domProps: {
      "value": (_vm.client.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client.note = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.waitForSave) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "data-testid": "client-banner-note-save"
    }
  }, [_vm._v("Uložit")]) : _c('button', {
    staticClass: "btn btn-primary disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])])] : [_c('button', {
    staticClass: "btn btn-sm btn-link text-secondary",
    attrs: {
      "data-testid": "client-banner-note-edit"
    },
    on: {
      "click": _vm.editNote
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), (_vm.client.note) ? _c('i', [_vm._v("Poznámka: ")]) : _vm._e(), _c('span', {
    attrs: {
      "data-testid": "client-banner-note"
    }
  }, [_vm._v(_vm._s(_vm.client.note))])]], 2), _vm._v(" "), _c('div', {}, [_c('client-auth', {
    attrs: {
      "client": _vm.client
    },
    on: {
      "reload-client": _vm.reloadClient
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('client-log', {
    attrs: {
      "opened": _vm.modalClientLogOpened,
      "clientId": _vm.client.id
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-077cba8c","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 354
// module chunks = 0